export default class AuthActions {
  static SET_USER = 'SET_USER';
  static REMOVE_USER = 'REMOVE_USER';

  static setUser (user) {
    return {
      type: AuthActions.SET_USER,
      payload: user
    }
  }

  static removeUser () {
    return {
      type: AuthActions.REMOVE_USER
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/actions.js